import { render, staticRenderFns } from "./SummaryTab.vue?vue&type=template&id=0057bc4d&scoped=true"
import script from "./SummaryTab.vue?vue&type=script&lang=ts"
export * from "./SummaryTab.vue?vue&type=script&lang=ts"
import style0 from "./SummaryTab.vue?vue&type=style&index=0&id=0057bc4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057bc4d",
  null
  
)

export default component.exports